<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
      @change="handleTabChange"
    >
      <v-tab v-for="(item, index) in visibleTabs" :key="index">
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(content, i) in items" :key="i">
        <component v-bind:is="content.content"> </component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { mapActions } from "vuex";

export default {
  components: {
    ComertialReport: () =>
      import("@/components/reports-kpis/ComertialReportV2.vue"),
    PlarformCampaignReport: () =>
      import("@/components/reports-kpis/PlatformCampaignReportV2.vue"),
    AnualMktReportVersion2: () =>
      import("@/components/reports-kpis/AnualMktReportVersion2.vue"),
    AvgTimeAttention: () =>
      import("@/components/reports-kpis/AvgTimeAttention.vue"),
    LeadMovements: () => import("@/components/reports-kpis/MovementsReport.vue")
  },
  data() {
    return {
      role: localStorage.getItem("user_role"),
      tab: null,
      items: [
        {
          tab: "Performance",
          content: "LeadMovements",
          route: "performance"
        },
        {
          tab: "Comercial",
          content: "ComertialReport",
          route: "comercial"
        },
        {
          tab: "Campañas/Plataforma",
          content: "PlarformCampaignReport",
          route: "campanas-plataforma"
        },
        {
          tab: "Anual MKT",
          content: "AnualMktReportVersion2",
          route: "anual-mkt"
        },
        {
          tab: "Tiempo de Atención",
          content: "AvgTimeAttention",
          route: "time-attention"
        }
      ],
      isDialogActive: false,
      userRole: localStorage.getItem("user_role") || ""
    };
  },
  computed: {
    visibleTabs() {
      return this.items;
    }
  },
  async mounted() {
    if (this.role) {
      if (this.role === "marketing" || this.role === "marketingv2") {
        this.items = [this.items[1], this.items[2], this.items[3]];
      }
      if (this.role === "developer") {
        this.items = [this.items[0], this.items[1]];
      }
    }
    await this.fetchfilters();
    this.initializeTabFromRoute();
  },
  methods: {
    ...mapActions({
      fetchfilters: "leads/filter/fetchGetLeadsFilters"
    }),
    handleTabChange(index) {
      const selectedItem = this.visibleTabs[index];
      if (this.$route.params.tab !== selectedItem.route) {
        this.$router.push({
          name: this.$route.name,
          params: { tab: selectedItem.route }
        });
      }
    },
    initializeTabFromRoute() {
      const currentTab = this.$route.params.tab;
      const tabIndex = this.items.findIndex(item => item.route === currentTab);
      if (tabIndex !== -1) {
        this.tab = tabIndex;
      } else {
        // Si no hay tab o no es válido para este rol, redirigir al primer tab disponible
        this.tab = 0;
        this.$router.replace({
          name: this.$route.name,
          params: { tab: this.items[0].route }
        });
      }
    }
  },
  watch: {
    "$route.params.tab": {
      handler(newTab) {
        // Buscar en todos los items para permitir acceso directo por URL
        const tabIndex = this.items.findIndex(item => item.route === newTab);
        if (tabIndex !== -1 && tabIndex !== this.tab) {
          this.tab = tabIndex;
        }
      },
      immediate: true
    }
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>

<style></style>
